if (!customElements.get('b2b-product-select')) {
  class B2BProductSelect extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-product-trigger]');
      this.panel = this.querySelector('[data-product-panel]');
      this.search = this.querySelector('[data-product-search]');
      this.checkboxes = Array.from(this.querySelectorAll('[data-product-checkbox]'));
      this.options = Array.from(this.querySelectorAll('[data-product-option]'));
      this.output = this.querySelector('[data-products-output]');
      this.summary = this.querySelector('[data-product-summary]');
      this.count = this.querySelector('[data-product-count]');
      this.done = this.querySelector('[data-product-done]');
      this.error = this.querySelector('[data-product-error]');
      this.noResults = this.querySelector('[data-product-no-results]');
      this.form = this.closest('form');
      if (!this.trigger || !this.panel || !this.form) return;

      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.trigger.addEventListener('click', () => this.toggle(), { signal });
      this.done?.addEventListener('click', () => this.close(true), { signal });
      this.search?.addEventListener('input', () => this.filterOptions(), { signal });
      this.checkboxes.forEach((checkbox) => checkbox.addEventListener('change', () => this.syncSelection(), { signal }));
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          event.preventDefault();
          this.close(true);
        }
      }, { signal });
      this.form.addEventListener('submit', (event) => {
        this.syncSelection();
        if (!this.checkboxes.some((checkbox) => checkbox.checked)) {
          event.preventDefault();
          this.showError();
        }
      }, { signal });
      this.syncSelection();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    toggle() {
      this.panel.hidden ? this.open() : this.close();
    }

    open() {
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => this.search?.focus({ preventScroll: true }));
    }

    close(restoreFocus = false) {
      if (this.panel.hidden) return;
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.trigger.focus({ preventScroll: true });
    }

    filterOptions() {
      const query = this.search.value.trim().toLowerCase();
      let visibleCount = 0;
      this.options.forEach((option) => {
        const matches = !query || option.dataset.title.includes(query);
        option.hidden = !matches;
        if (matches) visibleCount += 1;
      });
      if (this.noResults) this.noResults.hidden = visibleCount > 0;
    }

    syncSelection() {
      const selected = this.checkboxes.filter((checkbox) => checkbox.checked);
      this.output.value = selected.map((checkbox) => checkbox.value).join(', ');
      this.count.textContent = selected.length === 1 ? '1 product selected' : `${selected.length} products selected`;
      this.summary.textContent = selected.length === 0
        ? 'Choose one or more products'
        : selected.length === 1
          ? selected[0].value
          : `${selected.length} products selected`;
      if (selected.length > 0) this.clearError();
    }

    showError() {
      this.error.textContent = this.dataset.emptyMessage || 'Please select at least one product.';
      this.error.hidden = false;
      this.trigger.setAttribute('aria-invalid', 'true');
      this.trigger.setAttribute('aria-describedby', this.ensureErrorId());
      this.trigger.focus({ preventScroll: true });
      this.trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    clearError() {
      this.error.hidden = true;
      this.trigger.removeAttribute('aria-invalid');
      this.trigger.removeAttribute('aria-describedby');
    }

    ensureErrorId() {
      if (!this.error.id) this.error.id = `B2BProductError-${Math.random().toString(36).slice(2, 9)}`;
      return this.error.id;
    }
  }

  customElements.define('b2b-product-select', B2BProductSelect);
}
